// extracted by mini-css-extract-plugin
export default {"themedComponent":"themedComponent_DHUr","themedComponent--light":"themedComponent--light_DIHH","themedComponent--dark":"themedComponent--dark_Bv2M"};